module.exports = __webpack_public_path__ + "img/Baseline_V1.25b8df2b.png";